import type { ParseConfig } from 'papaparse';

export interface CsvParseRequest {
  file: File;
}

export type CsvParseResponse =
  { type: 'rows'; rows: string[][] } | { type: 'error'; message: string };

export const CSV_PARSE_OPTIONS: ParseConfig<string[]> = { skipEmptyLines: true, header: false };
